import { Box, Divider, useMediaQuery, useTheme } from "@mui/material";
import DesktopFooter from "./DesktopFooter";
import MobileFooter from "./MobileFooter";
import { useClientPortalConfigContext } from "../../../context";

import styles from "./Footer.module.css";

export default function Footer() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { clientPortalConfig } = useClientPortalConfigContext();

    const enableZandaFooter = clientPortalConfig?.enableZandaFooter ?? true;

    return (
        <Box component="footer" className={styles.footer} data-test-id="section_footer">
            <Divider flexItem className={styles.divider} data-test-id="divider_footer" />
            {isMobile ? (
                <MobileFooter enableZandaFooter={enableZandaFooter} />
            ) : (
                <DesktopFooter enableZandaFooter={enableZandaFooter} />
            )}
        </Box>
    );
}
